export const ENDPOINTS = {
  getRoom: '/gateway/admin/rooms/:id',
  getRooms: '/gateway/admin/rooms',
  createRoom: '/gateway/admin/rooms',
  updateRoom: '/gateway/admin/rooms/:id',
  deleteRoom: '/gateway/admin/rooms/:id',
  publishRoom: '/gateway/admin/rooms/:roomId/publish',
  unpublishRoom: '/gateway/admin/rooms/:roomId/unpublish',
} as const;

export const CORE_QUERY_KEYS = {
  rooms: 'admin-rooms',
  room: 'admin-room',
} as const;
